import { Injectable } from '@angular/core';
import { generateUUID } from '../../../shared/utils/generate-uuid.util';
import { HappyStoreStorageService } from './happy-store-storage.service';

@Injectable({ providedIn: 'root' })
export class HappyGuestSessionService {
  private readonly GUEST_SESSION_KEY = 'happy_guest_session_id';

  constructor(private happyStoreStorageService: HappyStoreStorageService) {}

  getOrCreateGuestSessionId(): string {
    const existingId = this.readGuestSessionId();
    if (existingId) {
      return existingId;
    }

    const nextId = generateUUID();
    this.writeGuestSessionId(nextId);
    return nextId;
  }

  refreshGuestSessionId(): string {
    const nextId = generateUUID();
    this.writeGuestSessionId(nextId);
    return nextId;
  }

  private readGuestSessionId(): string {
    try {
      return this.happyStoreStorageService.getSessionItem(this.GUEST_SESSION_KEY) || '';
    } catch (error) {
      console.warn('Failed to read Happy guest session id:', error);
      return '';
    }
  }

  private writeGuestSessionId(guestSessionId: string): void {
    try {
      this.happyStoreStorageService.setSessionItem(
        this.GUEST_SESSION_KEY,
        guestSessionId
      );
    } catch (error) {
      console.warn('Failed to save Happy guest session id:', error);
    }
  }
}
